import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import LogoPolderzicht from '../assets/logo_polderzicht_kantoorlaag.png';
import '../css/SchoonmaakPortaal.css';

const API_URL = '';

const STATUS_META = {
  over_tijd: { label: 'Over tijd', cls: 'over_tijd' },
  nieuw: { label: 'Nog niet gedaan', cls: 'nieuw' },
  binnenkort: { label: 'Binnenkort', cls: 'binnenkort' },
  op_schema: { label: 'Op schema', cls: 'op_schema' }
};

const fmtDatum = (iso) => iso
  ? new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' })
  : '';

const SchoonmaakPortaal = () => {
  const { token } = useParams();
  const [taken, setTaken] = useState([]);
  const [aantalOverTijd, setAantalOverTijd] = useState(0);
  const [loading, setLoading] = useState(true);
  const [errorState, setErrorState] = useState(null); // 'notfound' | 'generic'
  const [busy, setBusy] = useState({}); // { [id]: true }

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/schoonmaak/${token}`);
      if (res.status === 404) { setErrorState('notfound'); return; }
      if (!res.ok) { setErrorState('generic'); return; }
      const data = await res.json();
      setTaken(data.taken || []);
      setAantalOverTijd(data.aantalOverTijd || 0);
      setErrorState(null);
    } catch {
      setErrorState('generic');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const actie = async (taak, soort) => {
    setBusy(prev => ({ ...prev, [taak._id]: true }));
    try {
      const res = await fetch(`${API_URL}/api/schoonmaak/${token}/${taak._id}/${soort}`, { method: 'POST' });
      if (!res.ok) throw new Error('mislukt');
      await fetchData();
    } catch {
      setErrorState('generic');
    } finally {
      setBusy(prev => { const { [taak._id]: _, ...rest } = prev; return rest; });
    }
  };

  if (loading) {
    return <div className="sm-page"><div className="sm-container"><p>Laden…</p></div></div>;
  }

  if (errorState === 'notfound') {
    return (
      <div className="sm-page">
        <div className="sm-container">
          <div className="sm-header"><img src={LogoPolderzicht} alt="VVE Polderzicht" className="sm-logo" /></div>
          <div className="sm-alert error">Deze link bestaat niet (meer). Vraag het bestuur om de juiste link.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="sm-page">
      <div className="sm-container">
        <div className="sm-header">
          <img src={LogoPolderzicht} alt="VVE Polderzicht" className="sm-logo" />
          <h1>Schoonmaak VvE Polderzicht</h1>
          <p className="sm-sub">Vink af wat je hebt gedaan — de datum wordt automatisch vastgelegd.</p>
        </div>

        {aantalOverTijd > 0
          ? <div className="sm-signaal">⚠ {aantalOverTijd} {aantalOverTijd === 1 ? 'taak is' : 'taken zijn'} over tijd</div>
          : <div className="sm-signaal ok">✓ Alles op schema</div>}

        {errorState === 'generic' && <div className="sm-alert error">Er ging iets mis. Probeer het opnieuw.</div>}

        {taken.map(t => {
          const st = STATUS_META[t.status] || STATUS_META.op_schema;
          return (
            <div key={t._id} className={`sm-taak sm-${st.cls}`}>
              <div className="sm-taak-head">
                <span className="sm-titel">{t.titel}</span>
                <span className={`sm-badge ${st.cls}`}>
                  {st.label}{t.status === 'over_tijd' && t.dagenOverTijd ? ` · ${t.dagenOverTijd}d` : ''}
                </span>
              </div>
              <p className="sm-omschr">{t.omschrijving}</p>
              <div className="sm-meta">
                <span className="sm-freq">{t.frequentieLabel}</span>
                <span className="sm-laatst">{t.laatstGedaan ? `Laatst gedaan: ${fmtDatum(t.laatstGedaan)}` : 'Nog nooit afgevinkt'}</span>
              </div>
              <div className="sm-acties">
                <button className="sm-done" disabled={busy[t._id]} onClick={() => actie(t, 'gedaan')}>
                  ✓ Gedaan{t.laatstGedaan ? ' (opnieuw)' : ''}
                </button>
                {t.laatstGedaan && (
                  <button className="sm-undo" disabled={busy[t._id]} onClick={() => actie(t, 'ongedaan')}>
                    Terugdraaien
                  </button>
                )}
              </div>
            </div>
          );
        })}

        <div className="sm-footer">
          <p>Vragen? Mail <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
};

export default SchoonmaakPortaal;
